import type { PayloadAction } from "@reduxjs/toolkit";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "services/api.ts";
import type { RREDataType } from "types/DataTypes";

type InitialState = {
  currentRRE: RREDataType | null; //
  showUploadModal: boolean;
  showDownloadModal: boolean;
  showAddRreModal: boolean;
  showAddPolicyModal: boolean;
  showSendCMSFileModal: boolean;
  showAddRRETagModal: boolean;
  showEditRRETagModal: boolean;
};

const rreSlice = createSlice({
  name: "rre",
  initialState: {
    currentRRE: null,
    showUploadModal: false,
    showDownloadModal: false,
    showAddRreModal: false,
    showAddPolicyModal: false,
    showSendCMSFileModal: false,
    showAddRRETagModal: false,
    showEditRRETagModal: false,
  } as InitialState,
  reducers: {
    setRRE(state, action: PayloadAction<RREDataType>) {
      state.currentRRE = action.payload;
    },
    setShowUploadModal(state, action: PayloadAction<boolean>) {
      state.showUploadModal = action.payload;
    },
    setShowDownloadModal(state, action: PayloadAction<boolean>) {
      state.showDownloadModal = action.payload;
    },
    setShowAddPolicyModal(state, action: PayloadAction<boolean>) {
      state.showAddPolicyModal = action.payload;
    },
    setShowSendCMSFileModal(state, action: PayloadAction<boolean>) {
      state.showSendCMSFileModal = action.payload;
    },
    setShowAddRRETagModal(state, action: PayloadAction<boolean>) {
      state.showAddRRETagModal = action.payload;
    },
    setShowEditRRETagModal(state, action: PayloadAction<boolean>) {
      state.showEditRRETagModal = action.payload;
    },
  },
});

export const fetchRreAndUpdateStore = createAsyncThunk(
  "rre/fetchRreAndUpdateStore",
  async (
    { accessToken, rreId }: { accessToken: string; rreId: string },
    { dispatch },
  ) => {
    const result = await dispatch(
      // @ts-expect-error TODO: fix this
      api.endpoints.getRreById.initiate({ accessToken, rreId }),
    );
    if ("data" in result) {
      return result.data;
    }
    throw new Error(
      `Failed to fetch rre data for id ${rreId}. Check the validity of the id.`,
    );
  },
);

const { reducer } = rreSlice;

export const {
  setRRE,
  setShowUploadModal,
  setShowAddPolicyModal,
  setShowSendCMSFileModal,
  setShowDownloadModal,
  setShowAddRRETagModal,
  setShowEditRRETagModal,
} = rreSlice.actions;

export default reducer;
